import PhotoUpload from "./scripts/PhotoUpload"; // New component
import React from "react";
import ReactDOM from "react-dom/client";

// Add photo upload functionality
if (document.querySelector("#photo-upload-container")) {
  const container = document.querySelector("#photo-upload-container");
  const parkId = container.dataset.parkId;

  if (!parkId) {
    console.error("No park ID found in data-park-id attribute");
  }

  const root = ReactDOM.createRoot(container);
  root.render(<PhotoUpload parkId={parkId} />);
}

document.addEventListener("DOMContentLoaded", function () {
  // Mobile filter toggle
  const filterToggle = document.getElementById("filter-toggle");
  const filtersSection = document.getElementById("filters-section");
  const activeFiltersCount = document.getElementById("active-filters-count");

  if (filterToggle && filtersSection) {
    filterToggle.addEventListener("click", function () {
      filtersSection.classList.toggle("hidden");
      filtersSection.classList.toggle("block");
    });
  }

  // Show/hide more categories
  const showMoreBtn = document.getElementById("show-more-categories");
  const moreCategories = document.getElementById("more-categories");

  if (showMoreBtn && moreCategories) {
    showMoreBtn.addEventListener("click", function () {
      moreCategories.classList.toggle("hidden");
      this.textContent = moreCategories.classList.contains("hidden")
        ? "+<?php echo count($park_categories) - 8; ?> More"
        : "Show Less";
    });
  }

  // Show/hide more features
  const moreFeaturesToggle = document.getElementById("more-features-toggle");
  const moreFeatures = document.getElementById("more-features");

  if (moreFeaturesToggle && moreFeatures) {
    moreFeaturesToggle.addEventListener("click", function () {
      moreFeatures.classList.toggle("hidden");
      this.innerHTML = moreFeatures.classList.contains("hidden")
        ? "Show More Features ↓"
        : "Show Fewer Features ↑";
    });
  }

  // Update active filters count
  function updateActiveFiltersCount() {
    if (!activeFiltersCount) return;

    let count = 0;

    // Count search term
    const searchInput = document.querySelector(
      'input[name="<?php echo esc_js($search_input_name); ?>"]'
    );
    if (searchInput && searchInput.value.trim()) count++;

    // Count select filters
    const selects = filtersSection.querySelectorAll("select");
    selects.forEach((select) => {
      if (select.value) count++;
    });

    // Count checkbox filters
    const checkboxes = filtersSection.querySelectorAll(
      'input[type="checkbox"]:checked'
    );
    count += checkboxes.length;

    if (count > 0) {
      activeFiltersCount.textContent = count;
      activeFiltersCount.classList.remove("hidden");
    } else {
      activeFiltersCount.classList.add("hidden");
    }
  }

  // Update count on page load and when filters change
  updateActiveFiltersCount();

  if (filtersSection) {
    filtersSection.addEventListener("change", updateActiveFiltersCount);
    filtersSection.addEventListener("input", updateActiveFiltersCount);
  }
});
